import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";

export default function HeatPress() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const rows = (settings?.press_rows || []).filter((r) => r.product);
  if (!settings || !rows.length) return null;

  return (
    <section id="heat-press" data-testid="heat-press-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      <div className="flex items-center gap-3">
        <Flame className="text-yellow-300" size={20} />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-yellow-300" data-testid="heat-press-eyebrow">{settings.press_eyebrow}</p>
      </div>
      <h2 className="mt-2 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" data-testid="heat-press-title">
        {settings.press_title}
      </h2>
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="mt-10 overflow-x-auto rounded-2xl border border-white/10"
      >
        <table className="w-full min-w-[640px] text-left" data-testid="heat-press-table">
          <thead>
            <tr className="border-b border-white/10 bg-[#12141A] font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              <th className="px-6 py-4">Product</th>
              <th className="px-6 py-4 text-cyan-400">Temperature</th>
              <th className="px-6 py-4 text-fuchsia-400">Time</th>
              <th className="px-6 py-4 text-yellow-300">Pressure</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.product + i} data-testid={`heat-press-row-${i}`} className={`border-b border-white/5 text-sm transition-colors hover:bg-white/[0.03] ${i % 2 ? "bg-[#0F1015]" : ""}`}>
                <td className="px-6 py-4 font-medium text-slate-200">{r.product}</td>
                <td className="px-6 py-4 font-mono text-cyan-300">{r.temp}</td>
                <td className="px-6 py-4 font-mono text-fuchsia-300">{r.time}</td>
                <td className="px-6 py-4 font-mono text-yellow-200">{r.pressure}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </section>
  );
}
